import React, { ReactNode } from 'react';
import { TableBody, TableHead, useTheme } from '@mui/material';
import { StyledTable } from './Table.styles';

export interface TableProps {
  header: ReactNode | ReactNode[];
  body: ReactNode | ReactNode[];
}

const Table: React.FC<TableProps> = ({ header, body }) => {
  const theme = useTheme();
  return (
    <StyledTable>
      <TableHead
        sx={{
          overflow: 'hidden',
          backgroundColor: theme.palette.grey[200],
        }}
      >
        {header}
      </TableHead>
      <TableBody>{body}</TableBody>
    </StyledTable>
  );
};

export default Table;
